import { render, staticRenderFns } from "./CloseIcon.vue?vue&type=template&id=0adc660c&scoped=true&"
import script from "./CloseIcon.vue?vue&type=script&lang=js&"
export * from "./CloseIcon.vue?vue&type=script&lang=js&"
import style0 from "./CloseIcon.vue?vue&type=style&index=0&id=0adc660c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0adc660c",
  null
  
)

export default component.exports